import { useState } from 'react';
import { createSessionStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';
import type { IssueRestoreMeta } from '../../common/types.tsx';
import { BROWSER_STORAGE_PREFIX } from '../constants.tsx';

// Keeping this async to future proof for moving this to backend rather than browser storage
export interface IssueRestoreMetaService {
	getIssueRestoreMeta: () => Promise<IssueRestoreMeta | undefined>;
	createIssueRestoreMeta: (data: IssueRestoreMeta) => Promise<IssueRestoreMeta>;
	updateIssueRestoreMeta: (data: IssueRestoreMeta) => Promise<IssueRestoreMeta>;
	deleteIssueRestoreMeta: () => Promise<void>;
}

const KEY = 'issue-restore-meta';

export const useIssueRestoreMetaService = (): IssueRestoreMetaService => {
	const [storage] = useState(createSessionStorageProvider(`${BROWSER_STORAGE_PREFIX}`));

	return {
		getIssueRestoreMeta: async () => storage.get(KEY),
		createIssueRestoreMeta: async (data) => {
			storage.set(KEY, data);
			return data;
		},
		updateIssueRestoreMeta: async (data) => {
			storage.set(KEY, data);
			return data;
		},
		deleteIssueRestoreMeta: async () => {
			storage.remove(KEY);
		},
	};
};
